module.exports = __webpack_public_path__ + "img/upc.960b69dd.jpg";